import {
  type ClientInferResponseBody,
  type ClientInferRequest
} from "@ts-rest/core";

import { client } from "../client";
import { type apiContract } from "../contract";

type CreateOrderSimpleRequest = ClientInferRequest<
  typeof apiContract.v1.pos.tills.createOrderSimple
>;

export type CreateOrderSimpleArgs = CreateOrderSimpleRequest["params"] &
  CreateOrderSimpleRequest["body"];

export async function createOrderSimple({
  tillId,
  ...body
}: CreateOrderSimpleArgs) {
  const response = await client.v1.pos.tills.createOrderSimple({
    params: { tillId },
    body
  });

  if (response.status === 201) {
    return response.body;
  }

  throw response;
}

type CreateOrderV3Request = ClientInferRequest<
  typeof apiContract.v3.pos.orders.create
>;

type CreateOrderAsyncRequest = ClientInferRequest<
  typeof apiContract.v4.pos.orders.async
>;

type AcknowledgeOrderPaymentV4Request = ClientInferRequest<
  typeof apiContract.v4.pos.orders.acknowledgePayment
>;

export type CreateOrderV3Args = CreateOrderV3Request["body"];

export type CreateOrderV4AsyncArgs = CreateOrderAsyncRequest["body"] &
  CreateOrderAsyncRequest["params"];

export type AcknowledgeOrderPaymentV4Args =
  AcknowledgeOrderPaymentV4Request["body"] &
    AcknowledgeOrderPaymentV4Request["params"];

export type CreateOrderV4AsyncResponse = ClientInferResponseBody<
  typeof apiContract.v4.pos.orders.async,
  201
>;

export async function createOrderV4Async({
  tillId,
  ...body
}: CreateOrderV4AsyncArgs) {
  const response = await client.v4.pos.orders.async({
    body,
    params: {
      tillId
    }
  });

  if (response.status === 201) {
    return response.body;
  }

  throw response;
}

export async function acknowledgeOrderPaymentV4({
  tillId,
  orderId,
  paymentId,
  ...body
}: AcknowledgeOrderPaymentV4Args) {
  const response = await client.v4.pos.orders.acknowledgePayment({
    body,
    params: {
      tillId,
      orderId,
      paymentId
    }
  });

  if (response.status === 200) {
    return response.body;
  }

  throw response;
}

export async function createOrderV3(body: CreateOrderV3Args) {
  const response = await client.v3.pos.orders.create({
    body
  });

  if (response.status === 201) {
    return response.body;
  }

  throw response;
}

type CreateOrderV1Request = ClientInferRequest<
  typeof apiContract.v1.pos.orders.create
>;

export type CreateOrderV1Args = CreateOrderV1Request["body"];

export async function createOrderV1(body: CreateOrderV1Args) {
  const response = await client.v1.pos.orders.create({
    body
  });

  if (response.status === 201) {
    return response.body;
  }

  throw response;
}

export type CreateOrderBasket = ((
  | CreateOrderV3Args["basket"]
  | CreateOrderV1Args["basket"]
)[number] & { description?: string })[];

type CreatePreOrdersRequest = ClientInferRequest<
  typeof apiContract.v1.collect.children.createOrders
>;

export type CreatePreOrdersArgs = CreatePreOrdersRequest["params"] &
  CreatePreOrdersRequest["body"];

export async function createPreOrders({
  tillId,
  ...body
}: CreatePreOrdersArgs) {
  const response = await client.v1.collect.children.createOrders({
    params: { tillId },
    body
  });

  if (response.status === 201) {
    return response.body;
  }

  throw response;
}
